import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { R1FactType } from '@/api/rest/resources/types/fact';
import { CanopyHeightHistoricalChart } from '@/components/Charts';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { GraphFact } from '@/components/Charts/types';
import { GraphTileProps } from '@/components/IndicatorCard/GraphTile';
import { useOrganizationIndicatorGraphFact } from '@/pages/shared/hooks/useOrganizationFact';
import { NoData } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/components/NoData';

export const CanopyHeightGraphTile = (props?: GraphTileProps | null) => {
  const { t } = useTranslation();
  const plotGroupId = props?.plotGroupId ?? null;

  const canopyHeightHistoricFact = R1FactType.r1_soil_carbon_historic_total_graph;
  const { [canopyHeightHistoricFact]: canopyHeightHistoric } = useOrganizationIndicatorGraphFact<GraphFact[]>(
    canopyHeightHistoricFact,
    null,
    undefined,
    plotGroupId,
  ); // TODO: MVP-4772 - change with forest fact
  const chartData = canopyHeightHistoric?.value;

  const noChartData = !chartData?.length;
  if (noChartData) {
    return <NoData />;
  }

  return (
    <Stack center data-testid='canopy-height-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={t('shared.ncaDetail.details.forest.labels.historicalCanopyHeightGraphHeadline')}
          popover={{
            title: t('shared.ncaDetail.details.forest.explainers.historicalCanopyHeight.title'),
            body: t('shared.ncaDetail.details.forest.explainers.historicalCanopyHeight.body'),
          }}
          className='w-full px-6 sm:px-0'
        />
        <CanopyHeightHistoricalChart data={chartData} showTooltip={true} data-testid='canopy-height-historic-chart' />
      </Stack>
    </Stack>
  );
};
